import React, { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { tableColumns } from './LearningData';
import { Button, Form, Modal } from 'react-bootstrap';
import CreateLearning from './CreateLearning';
import EditIcon from '../../assets/images/svg/editLearning.svg';
import ShareIcon from '../../assets/images/svg/publishLearning.svg';
import ArchiveIcon from '../../assets/images/svg/archiveLearning.svg';
import EditLearning from './EditLearning';
// import axios from 'axios';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import ArchiveEnabled from '../../assets/images/svg/archiveEnabled.svg';
import Search from '../../assets/images/svg/Search_SoS.svg';
import SearchIcon from '../../assets/images/svg/search_iconSos.svg';
import Calendar from '../../assets/images/svg/Calendar_SoS.svg';
import Filter from '../../assets/images/svg/Filter_SoS.svg';

// Import date range picker
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { _axios } from '../../utils/axios';

const tableStyles = `
  .rdt_TableCell {
    padding: 4px 2px !important;
  }
  .rdt_TableHead {
    padding: 4px 2px !important;
  }
  .rdt_TableCol {
    padding: 4px 2px !important;
  }
.rdt_TableCell[data-column-id="status"] {
    position: sticky !important;
    right: 160px !important;
    background-color: white !important;
    z-index: 2 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.rdt_TableHeadRow [data-column-id="status"] {
    position: sticky !important;
    right: 160px !important;
    background-color: white !important;
    z-index: 2 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    padding-left: 10px !important;
    padding-right: 0 !important;
}
  .rdt_TableCell[data-column-id="action"] {
    position: sticky !important;
    right: 0 !important;
    background-color: inherit !important;
    z-index: 1;
  }
  .rdt_TableHeadRow [data-column-id="action"] {
    position: sticky !important;
    right: 0 !important;
    background-color: inherit !important;
    z-index: 1;
  }
  .data-tables {
    overflow-x: auto;
  }
    .btn[title]:hover:after {
    content: attr(title);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 4px 8px;
    color: white;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
}
.btn[title] {
    position: relative;
}
    .btn-link:hover {
    text-decoration: none !important;
}
 .btn[disabled] {
    cursor: not-allowed;
}   
`;

const LearningTable = () => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelete, setToggleDelete] = useState(false);
    const [data, setData] = useState([]);
    const [showCreate, setShowCreate] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [editRowData, setEditRowData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalConfig, setModalConfig] = useState({
        type: '',
        artifactId: null
    });

    // New state variables for search, calendar, and filter functionality
    const [originalData, setOriginalData] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const searchRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [showCalendar, setShowCalendar] = useState(false);
    const calendarRef = useRef(null);
    const [dateRange, setDateRange] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection'
        }
    ]);
    const filterOptions = [
        { label: 'All', value: 'all' },
        { label: 'New', value: 'NEW' },
        { label: 'Active', value: 'ACTIVE' },
        { label: 'Archived', value: 'ARCHIVED' }
    ];

    // Click outside handlers for search, dropdown, and calendar
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearch(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await _axios.get(`${ServerPath}/artifacts/admin`);
            console.log("Full Artifacts Data: ", response);

            if (response.data.success) {
                console.log("Response", response);
                const transformedData = response.data.data.map(item => ({
                    id: item.id,
                    artifact_id: item.artifact_id,
                    title: item.title,
                    description: item.short_description,
                    description_hin: item.short_description_hin,
                    description_mar: item.short_description_mar,
                    description_guj: item.short_description_guj,
                    type: formatArtifactType(item.artifact_type),
                    category: getCategoryName(item.category_id),
                    // Add new promote_as field
                    promote_as: getPromoteAs(item.is_by_guruji, item.is_trending),
                    // Add formatted created date
                    created_date: formatDate(item.created_at),
                    status: formatStatus(item.status),
                    lyrics_data: item.lyrics_data,
                    status_component: (
                        <span className="d-inline-block"
                            style={{
                                minWidth: '70px',
                                textAlign: 'center',
                                borderRadius: '20px',
                                padding: '4px 8px',
                                backgroundColor: getStatusColor(item.status),
                                color: '#FFFFFF',
                                fontSize: '10px',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                border: '1px solid rgba(255, 255, 255, 0.1)'
                            }}
                        >
                            {formatStatus(item.status)}
                        </span>
                    ),
                    action: (
                        <div className="d-flex justify-content-center gap-2">
                            <button
                                className="btn btn-link p-0"
                                title="Edit"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEdit({
                                        raw_data: item  // ✅ JUST THIS - same as CourseTable does
                                    });
                                }}
                            >
                                <img src={EditIcon} alt="edit" style={{ width: '24px', height: '24px' }} />
                            </button>
                            <div title={item.status === 'ACTIVE' ? "Published" : "Publish"}>
                                <button
                                    className="btn btn-link p-0"
                                    disabled={item.status === 'ACTIVE'}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (item.status !== 'ACTIVE') {
                                            setModalConfig({
                                                type: 'publish',
                                                artifactId: item.artifact_id
                                            });
                                            setShowModal(true);
                                        }
                                    }}
                                    style={{ opacity: item.status === 'ACTIVE' ? 0.5 : 1 }}
                                >
                                    <img src={ShareIcon} alt="share" style={{ width: '24px', height: '24px' }} />
                                </button>
                            </div>
                            <div title={item.status === 'ARCHIVED' ? "Archived" : "Archive"}>
                                <button
                                    className="btn btn-link p-0"
                                    disabled={item.status === 'ARCHIVED'}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (item.status !== 'ARCHIVED') {
                                            setModalConfig({
                                                type: 'archive',
                                                artifactId: item.artifact_id
                                            });
                                            setShowModal(true);
                                        }
                                    }}
                                    style={{ opacity: item.status === 'ARCHIVED' ? 0.5 : 1 }}
                                >
                                    <img src={item.status === 'ARCHIVED' ? ArchiveEnabled : ArchiveIcon} alt="archive" style={{ width: '24px', height: '24px' }} />
                                </button>
                            </div>
                        </div>
                    ),
                    raw_data: item // Store the original data for edit purposes
                }));

                setData(transformedData);
                setOriginalData(transformedData); // Store original data for filtering
                setTotalRows(transformedData.length);
            }
        } catch (error) {
            console.error('Error fetching artifacts:', error);
            toast.error('Failed to fetch artifacts');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Helper functions for data formatting
    const formatArtifactType = (type) => {
        const typeMap = {
            'TEXT_LITERATURE': 'Text Literature',
            'AUDIO_ORALS': 'Audio or Orals',
            'LONG_VIDEOS': 'Long Videos',
            'SHORTS_REELS': 'Shorts or Reels'
        };
        return typeMap[type] || type;
    };
    const getCategoryName = (categoryId) => {
        const categoryMap = {
            // Long Videos and Shorts categories
            1: 'Discourses',
            2: 'Satsangs & Q&A',
            3: 'Spiritual Experiences',
            4: 'Life & Well-Being',
            5: 'Divine Moments',
            6: 'Guided Practices',
            7: 'Mantra Chanting',
            8: 'Scriptural Teachings',
            9: 'Parikrama Snippets',

            // Text Literature categories
            // 10: 'Scriptures',
            10: 'Teerthas',
            11: 'Stotras & Hymns',
            12: 'Divine Quotes',
            13: 'Ebooks',
            14: 'Reflections',
            15: 'Havan Vidhis',
            16: 'Astrological Forecasts',
            17: 'Pooja/Havan Vidhis',
            18: 'Essays or Blogs',
            19: 'Mantras',          // NEW
            20: 'Aartis',

            // Audio or Orals categories (shifted +2)
            21: 'Mantras & Chants',
            22: 'Stotra Recitations',
            23: 'Bhajans & Kirtans',
            24: 'Aarti & Daily Rituals',
            25: 'Discourses & Pravachans',
            26: 'Satsangs',
            27: 'Meditation & Guided Practice',
            28: 'Audio Books & Podcasts',
            29: 'Astrological Insights'
        };
        return categoryMap[categoryId] || '-';
    };

    const formatStatus = (status) => {
        return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    };

    const getStatusColor = (status) => {
        const colorMap = {
            'NEW': '#FFC107',
            'ACTIVE': '#00C853',
            'ARCHIVED': '#8B5CF6'
        };
        return colorMap[status] || '#8B5CF6';
    };

    const getPromoteAs = (isByGuruji, isTrending) => {
        if (isByGuruji) return 'Guruji';
        if (isTrending) return 'Trending';
        return '-';
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    // Search, filter and date range functions
    const handleSearch = (value) => {
        setSearchValue(value);
        // Get the current date range if it exists
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(value, selectedFilter, currentDateRange);
    };

    const handleFilterChange = (value) => {
        setSelectedFilter(value);
        // Get the current date range if it exists
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(searchValue, value, currentDateRange);
        setShowDropdown(false);
    };

    const handleDateRangeChange = (item) => {
        console.log('Date Range Selected:', item.selection);
        setDateRange([item.selection]);
        applyFiltersAndSearch(searchValue, selectedFilter, item.selection);
    };

    const clearDateFilter = () => {
        const clearedRange = {
            startDate: null,
            endDate: null,
            key: 'selection'
        };
        setDateRange([clearedRange]);
        applyFiltersAndSearch(searchValue, selectedFilter, null);
        setShowCalendar(false);
    };

    const applyFiltersAndSearch = (searchValue, filterValue, dateValue) => {
        let filteredData = [...originalData];

        // Apply search filter
        if (searchValue && searchValue.trim()) {
            const searchTerm = searchValue.toLowerCase();
            filteredData = filteredData.filter(item => {
                return (
                    String(item.artifact_id || '').toLowerCase().includes(searchTerm) ||
                    String(item.title || '').toLowerCase().includes(searchTerm) ||
                    String(item.description || '').toLowerCase().includes(searchTerm) ||
                    String(item.type || '').toLowerCase().includes(searchTerm) ||
                    String(item.category || '').toLowerCase().includes(searchTerm) ||
                    String(item.status || '').toLowerCase().includes(searchTerm)
                );
            });
        }

        // Apply status filter
        if (filterValue && filterValue !== 'all') {
            filteredData = filteredData.filter(item => {
                const rawStatus = item.raw_data?.status || '';
                return rawStatus === filterValue;
            });
        }

        // Apply date filter
        if (dateValue?.startDate && dateValue?.endDate) {
            filteredData = filteredData.filter(item => {
                const createdDate = new Date(item.raw_data.created_at);

                // Set time to start of day for consistent comparison
                const startDate = new Date(dateValue.startDate);
                startDate.setHours(0, 0, 0, 0);

                // Set time to end of day for consistent comparison
                const endDate = new Date(dateValue.endDate);
                endDate.setHours(23, 59, 59, 999);

                return createdDate >= startDate && createdDate <= endDate;
            });
        }

        setData(filteredData);
    };

    const handleEdit = (row) => {
        if (!row) return; // Add guard clause
        console.log("Waypoint ID:", row.raw_data.waypoint_id);
        console.log("Waypoint Name:", row.raw_data.waypoint_name);
        console.log("Data we have for editing:", row); // Debug log

        const rawData = row.raw_data;
        if (!rawData) return; // Add guard clause

        setEditRowData({
            title: rawData.title,
            title_hin: rawData.title_hin,        // ADD THIS
            title_mar: rawData.title_mar,        // ADD THIS
            title_guj: rawData.title_guj,
            description: rawData.short_description,
            description_hin: rawData.short_description_hin,
            description_mar: rawData.short_description_mar,
            description_guj: rawData.short_description_guj,
            artifactType: rawData.artifact_type,
            status: rawData.status,
            category: rawData.category_id,
            artifact_id: rawData.artifact_id,
            waypoint_id: rawData.waypoint_id ? Number(rawData.waypoint_id) : null,
            waypoint_name: rawData.waypoint_name || '',
            subscriptionType: rawData.subscription_type,
            media_url: rawData.media_url,
            media_url_hin: rawData.media_url_hin,
            media_url_mar: rawData.media_url_mar,
            media_url_guj: rawData.media_url_guj,
            thumbnail_url: rawData.thumbnail_url,
            created_at: rawData.created_at,
            last_updated_at: rawData.last_updated_at,
            promotions: {
                trending: Boolean(rawData.is_trending),
                byGuruji: Boolean(rawData.is_by_guruji)
            },
            is_a_part_of_course: rawData.is_a_part_of_course,
            is_a_part_of_explore: rawData.is_a_part_of_explore,
            lyrics_data: rawData.lyrics_data,
            author: rawData.author,
            languages: rawData.languages,
            deity_id: rawData.deity_id,
            journey_id: rawData.journey_id,
            saint_id: rawData.saint_id,
            project_id: rawData.project_id,
            container_id: rawData.container_id,
            listen_container_id: rawData.listen_container_id,
            lang_flag: rawData.lang_flag,
            read_id: rawData.read_id,
            listen_id: rawData.listen_id,
            watch_id: rawData.watch_id,
            read_flag: rawData.read_flag,
            listen_flag: rawData.listen_flag,
            watch_flag: rawData.watch_flag
        });
        setShowEdit(true);
    };
    const handlePublish = async (artifactId) => {
        try {
            const response = await _axios.put(`${ServerPath}/artifacts/${artifactId}`, {
                status: 'ACTIVE'
            });
            if (response.data.success) {
                toast.success('Article has been successfully published');
                window.location.reload();
                fetchData();
            }
        } catch (error) {
            console.error('Error publishing artifact:', error);
            toast.error('Failed to publish artifact');
        }
    };
    const handleDelete = async (artifactId) => {
        if (window.confirm('Are you sure you want to archive this artifact?')) {
            try {
                const response = await _axios.delete(`${ServerPath}/artifacts/${artifactId}`);
                if (response.data.success) {
                    toast.success('Artifact archived successfully');
                    window.location.reload();
                    fetchData(); // Refresh the data
                }
            } catch (error) {
                console.error('Error archiving artifact:', error);
                toast.error('Failed to archive artifact');
            }
        }
    };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    // const handlePageChange = (page) => {
    //     setCurrentPage(page);
    // };

    // const handlePerRowsChange = (newPerPage, page) => {
    //     setPerPage(newPerPage);
    //     setCurrentPage(page);
    // };

    const handleEditClose = (shouldRefresh = false) => {
        setShowEdit(false);
        setEditRowData(null);
        // fetchData(); // Refresh data after edit
        if (shouldRefresh) {
            fetchData(); // ✅ Only refresh if explicitly told to
        }
    };

    const handleCreateClose = (shouldRefresh = false) => {
        setShowCreate(false);
        // fetchData(); // Refresh data after creation
        if (shouldRefresh) {
            fetchData(); // ✅ Only refresh if explicitly told to
        }
    };
    const handleModalConfirm = async () => {
        try {
            if (modalConfig.type === 'publish') {
                const response = await _axios.put(`${ServerPath}/artifacts/${modalConfig.artifactId}/`, {
                    status: 'ACTIVE'
                });
                if (response.data.success) {
                    toast.success('Article has been successfully published');
                    window.location.reload();
                    fetchData();
                }
            } else if (modalConfig.type === 'archive') {
                const response = await _axios.put(`${ServerPath}/artifacts/${modalConfig.artifactId}/`, {
                    status: 'ARCHIVED'  // Changed from DELETE to PUT request
                });
                if (response.data.success) {
                    toast.success('Article has been successfully archived');
                    window.location.reload();
                    fetchData();
                }
            }
        } catch (error) {
            toast.error('Operation failed');
        }
        setShowModal(false);
    };

    return (
        <Fragment>
            <style>{tableStyles}</style>
            <Container fluid={true}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="mb-0">Knowledge</h3>
                    <div className="d-flex align-items-center gap-3">
                        {/* Search Component */}
                        <div className="position-relative" ref={searchRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowSearch(true)}
                            >
                                <img src={Search} alt="search" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showSearch && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '45px',
                                        left: '-180px',
                                        width: '220px',
                                        zIndex: 1000
                                    }}
                                >
                                    <div
                                        style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            padding: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                background: '#F8F7FA',
                                                borderRadius: '6px',
                                                padding: '6px 12px'
                                            }}
                                        >
                                            <input
                                                type="text"
                                                placeholder="Search Here..."
                                                value={searchValue}
                                                onChange={(e) => handleSearch(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    background: 'transparent',
                                                    fontSize: '14px',
                                                    color: '#666',
                                                    outline: 'none'
                                                }}
                                                autoFocus
                                            />
                                            <button
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                                onClick={() => handleSearch(searchValue)}
                                            >
                                                <img src={SearchIcon} alt="search" style={{ width: '20px', height: '20px' }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Calendar Component */}
                        <div className="position-relative" ref={calendarRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowCalendar(!showCalendar)}
                            >
                                <img src={Calendar} alt="calendar" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showCalendar && (
                                <div
                                    className="position-absolute end-0 mt-2 bg-white rounded shadow p-3"
                                    style={{
                                        width: 'auto',
                                        maxWidth: '300px',
                                        zIndex: 1000,
                                        right: 0
                                    }}
                                >
                                    <style>
                                        {`
                                        .date-range {
                                            font-size: 12px !important;
                                        }
                                        .date-range .rdrMonth {
                                            width: 240px !important;
                                            padding: 0 !important;
                                        }
                                        .date-range .rdrCalendarWrapper {
                                            font-size: 12px !important;
                                            width: 240px !important;
                                            border-radius: 8px !important;
                                            overflow: hidden !important;
                                            background: white !important;
                                        }
                                        .date-range .rdrDateDisplayWrapper {
                                            display: none !important;
                                        }
                                        .rdrMonthAndYearWrapper {
                                            padding-top: 5px !important;
                                            height: 40px !important;
                                        }
                                        .rdrMonth {
                                            padding: 0 !important;
                                        }
                                    `}
                                    </style>
                                    <DateRange
                                        editableDateInputs={true}
                                        onChange={handleDateRangeChange}
                                        moveRangeOnFirstSelection={false}
                                        ranges={dateRange}
                                        maxDate={new Date()}
                                        months={1}
                                        direction="horizontal"
                                        className="date-range"
                                        staticRanges={[]}
                                        inputRanges={[]}
                                        rangeColors={['#0066ff']}
                                        minDate={new Date("2000-01-01")}
                                        showSelectionPreview={true}
                                        showMonthAndYearPickers={true}
                                        monthDisplayFormat="MMMM yyyy"
                                        dayDisplayFormat="d"
                                        showDateDisplay={false}
                                        monthsShown={1}
                                    />
                                    <div className="d-flex justify-content-end mt-2">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={clearDateFilter}
                                        >
                                            Clear
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Filter Component */}
                        <div className="position-relative" ref={dropdownRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowDropdown(!showDropdown)}
                            >
                                <img src={Filter} alt="filter" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showDropdown && (
                                <div className="position-absolute end-0 mt-2 bg-white rounded shadow p-2"
                                    style={{ width: '200px', zIndex: 1000 }}>
                                    <Form>
                                        {filterOptions.map((option) => (
                                            <Form.Check
                                                key={option.value}
                                                type="checkbox"
                                                name="filterOption"
                                                id={`filter-${option.value}`}
                                                label={option.label}
                                                checked={selectedFilter === option.value}
                                                onChange={() => handleFilterChange(option.value)}
                                            />
                                        ))}
                                    </Form>
                                </div>
                            )}
                        </div>

                        {/* Create Button */}
                        <Button
                            variant="primary"
                            onClick={() => setShowCreate(true)}
                            className="bg-primary"
                        >
                            Create Artifact
                        </Button>
                    </div>
                </div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <DataTable
                                    columns={tableColumns}
                                    data={data}
                                    selectableRows
                                    pagination
                                    paginationServer={false}
                                    paginationTotalRows={totalRows}
                                    // onChangePage={handlePageChange}
                                    // onChangeRowsPerPage={handlePerRowsChange}
                                    onSelectedRowsChange={handleRowSelected}
                                    clearSelectedRows={toggleDelete}
                                    progressPending={loading}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <CreateLearning show={showCreate} onHide={handleCreateClose} />
            <EditLearning
                show={showEdit}
                onHide={handleEditClose}
                artifactData={editRowData}
            />
            <ConfirmationModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onConfirm={handleModalConfirm}
                title="Are you sure?"
                message={modalConfig.type === 'publish'
                    ? "You want to set this artifact to 'Active'?\nThis will be published and make it visible to users."
                    : "You want to archive this artifact? Once archived,\nit will no longer be visible to users."}
            />
        </Fragment>
    );
};
const ConfirmationModal = ({ show, onHide, onConfirm, title, message }) => (
    <Modal show={show} onHide={onHide} centered>
        <Modal.Body className="text-center p-4">
            <div className="mb-4">
                <div className="rounded-circle bg-warning bg-opacity-10 d-inline-flex p-4 mb-3">
                    <i className="bi bi-exclamation-lg fs-4 text-warning"></i>
                </div>
                <h4>{title}</h4>
                <p className="text-secondary mb-0">{message}</p>
            </div>
            <div className="d-flex gap-2 justify-content-center">
                <Button variant="primary" className="px-4" onClick={onConfirm}>Yes</Button>
                <Button variant="danger" className="px-4" onClick={onHide}>Cancel</Button>
            </div>
        </Modal.Body>
    </Modal>
);

export default LearningTable;